export const stateKeys = {
  options: 'options',
  optionsCount: 'optionsCount',
  visible: 'visible',
  search: 'search',
  disabled: 'disabled',
  loading: 'loading',
  multiple: 'multiple',
  label: 'label',
  placeholder: 'placeholder',
  renderOption: 'renderOption',
  renderOptionGroup: 'renderOptionGroup',
  renderControl: 'renderControl',
  renderActions: 'renderActions',
  renderSelectedOption: 'renderSelectedOption',
  showSelectionActions: 'showSelectionActions',
  currentValue: 'currentValue',
  filteredOptions: 'filteredOptions',
  className: 'className',
};

export const getInitialState = () => ({
  [stateKeys.options]: [],
  [stateKeys.optionsCount]: 0,
  [stateKeys.disabled]: false,
  [stateKeys.search]: '',
  [stateKeys.loading]: false,
  [stateKeys.multiple]: false,
  [stateKeys.label]: undefined,
  [stateKeys.placeholder]: undefined,
  [stateKeys.renderOption]: undefined,
  [stateKeys.renderOptionGroup]: undefined,
  [stateKeys.renderControl]: undefined,
  [stateKeys.renderActions]: undefined,
  [stateKeys.renderSelectedOption]: undefined,
  [stateKeys.showSelectionActions]: false,
  [stateKeys.currentValue]: undefined,
  [stateKeys.filteredOptions]: [],
  [stateKeys.className]: undefined,
});

export const updatedProps = [
  stateKeys.disabled,
  stateKeys.loading,
  stateKeys.multiple,
  stateKeys.label,
  stateKeys.placeholder,
  stateKeys.renderOption,
  stateKeys.renderOptionGroup,
  stateKeys.renderControl,
  stateKeys.renderActions,
  stateKeys.renderSelectedOption,
  stateKeys.showSelectionActions,
  stateKeys.className,
];
